import { Button, FormControlLabel, Grid, Radio, RadioGroup, Stack, Typography } from '@mui/material';
import React, { useContext, useState } from 'react';
import { LanguageContext } from '../../../../../../libs/Context';
import BannerImages from './Components/BannerImages';
import Moderation from './Moderation/Moderation';
import RegistrationField from './Components/WithRegistration/Components/RegistrationsField';
import ReactDOM from 'react-dom';
import WebinarRegistrationPreview from '../WebinarRegistrationPreview';
import { updateMeeting } from '../../../../../actions/meeting_actions';
import { catchErr } from '../../../../../../libs/HelperContent';

const Registration = (props) =>
{
	const { form, setForm, handleBackCallBack, handleSkipFinish,
		handleDeletePop, handleNextCallBack } = props;
	const { language } = useContext(LanguageContext);
	const [ data, setData ] = useState({ ...form });
	const [ preview, setPreview ] = useState(false);

	const handleChange = (e) =>
	{
		const key = e.target.datase?.key || e.target.name;
		const value = e.target.value === 'true';

		setData({ ...data, [key]: value });
	};

	const handleSet = (key, value) =>
	{
		setData({ ...data, [key]: value });
	};

	const btnElement = document.getElementById('webinar_preview_button');

	const togglePreview = () =>
	{
		setPreview(!preview);
	};

	const handleNext = async () =>
	{
		const body:any = {
			id               : data?.id || form?.id,
			actionType       : 'updateWebinar',
			bannerImage      : data?.bannerImage,
			withRegistration : data?.withRegistration
		};
		// moderation       : data?.moderation,
		// registrationFields : data?.registrationFields,
		// anonymousAccess    : data?.anonymousAccess,

		if (body?.withRegistration)
		{
			body.moderation = data?.moderation;
			body.registrationFields = data?.registrationFields;
		}
		else
		{
			body.registrationFields = data?.registrationFields.slice(0, 2);
		}

		try
		{
			await updateMeeting(body);

			delete body.actionType;
			setForm((prev) => ({ ...prev, ...body }));
			handleNextCallBack();
		}
		catch (err)
		{
			catchErr(err);
		}
	};

	const handleBack = () =>
	{
		handleBackCallBack();
	};

	return (
		<>
			{btnElement && ReactDOM.createPortal(
				<Button variant='outlined' onClick={togglePreview}>
					{language?.preview}
				</Button>, btnElement)}
			<Stack direction='column' height='calc(100% - 56px)'>
				<Grid container px='var(--pixel16)' py='6px'>
					<Grid item xs={12} py='var(--pixel8)' sx={{ borderBottom: '1px solid rgba(0,0,0,0.20)' }}>
						<Typography variant='inherit' fontSize='var(--pixel18)' fontWeight={'var(--font500)'}>{language?.resgistrationSetup}</Typography>
						<Typography variant='inherit' pt='var(--pixel4)'>{language?.registrationTxt}</Typography>
						<RadioGroup
							row
							aria-labelledby='demo-controlled-radio-buttons-group'
							name='withRegistration'
							value={data?.withRegistration}
							onChange={handleChange}
						>
							<FormControlLabel value control={<Radio />}
								label={language?.widthRegistration}
							/>
							<FormControlLabel value={false} control={<Radio />}
								label={language?.withoutRegistration}
							/>
						</RadioGroup>
					</Grid>
					<Grid item xs={12}>
						<RegistrationField
							registration={data?.withRegistration}
							fieldsList={data?.registrationFields}
							handleSet={handleSet}
						/>
						{data?.withRegistration &&
						<Moderation moderation={data?.moderation} handleSet={handleSet}/>}
					</Grid>
					<BannerImages bannerImage={data?.bannerImage} handleSet={handleSet}/>
				</Grid>
			</Stack>
			<Grid
				container
				justifyContent={'space-between'}
				alignItems='center'
				p='var(--pixel16)'
			>
				<Stack
					direction='row'
					alignItems='center'
					spacing={1}
				>
					<Button
						variant='outlined'
						onClick={handleBack}
					>
						{language?.previous}
					</Button>
					<Button onClick={handleSkipFinish} variant='outlined'>
						{language?.skipandFinish}
					</Button>
				</Stack>
				<Grid item>
					<Stack direction='row' spacing={1}>
						<Button
							onClick={handleDeletePop}
							variant='outlined'
						>
							{language?.cancel}
						</Button>
						<Button
							variant='contained'
							sx={{ color: 'var(--whiteColor)' }}
							onClick={handleNext}
						>
							{language?.next}
						</Button>
					</Stack>
				</Grid>
			</Grid>
			{preview && ReactDOM.createPortal(
				<div className='flexCol mediaPreview alignCntr scrollY'>
					<WebinarRegistrationPreview data={data} handleClose={togglePreview}/>
				</div>
				, document.body)}
		</>

	);
};

export default Registration;
